import styled from '@emotion/styled';

const LayoutStyled = styled.div`

`;

export default LayoutStyled;
